import { render, staticRenderFns } from "./CallerLogDetails.vue?vue&type=template&id=02dad592&scoped=true"
import script from "./CallerLogDetails.vue?vue&type=script&lang=js"
export * from "./CallerLogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dad592",
  null
  
)

export default component.exports